import { rem } from 'polished';
import { css, DefaultTheme } from 'styled-components';

type CssReturnType = ReturnType<typeof css>;

const greaterThan =
  (
    breakpoint: keyof DefaultTheme['layout']['breakpoints'],
    styles: CssReturnType,
  ) =>
  ({ theme }: { theme: DefaultTheme }) => css`
    @media (min-width: ${rem(theme.layout.breakpoints[breakpoint])}) {
      ${styles};
    }
  `;

export const extraSmall = (styles: CssReturnType) => greaterThan('XS', styles);

export const small = (styles: CssReturnType) => greaterThan('S', styles);

export const medium = (styles: CssReturnType) => greaterThan('M', styles);

export const large = (styles: CssReturnType) => greaterThan('L', styles);
